import React from 'react';

const icbc = ({ ...r }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 65 24" {...r}>
			<path
				fill="#C4161C"
				fillRule="evenodd"
				d="M41.364 11.845c0 6.077 4.838 11.039 10.791 11.039 5.954 0 10.79-4.962 10.79-11.04 0-6.077-4.774-10.976-10.728-10.976s-10.853 4.9-10.853 10.977zm1.55 0c0-5.023 4.342-9.488 9.303-9.488 4.961 0 9.302 4.465 9.302 9.488s-4.34 9.488-9.302 9.488c-4.961 0-9.302-4.403-9.302-9.488z"
				clipRule="evenodd"
			></path>
			<path
				fill="#C4161C"
				fillRule="evenodd"
				d="M57.984 6.201v4.651H54.45v1.737h3.534v4.961h-4.96v-1.426h3.534v-2.109h-3.535V9.426h3.535V7.628h-3.535V6.2h4.961zm-11.348 0v4.651h3.597v1.737h-3.597v4.961h4.96v-1.426h-3.534v-2.109h3.535V9.426h-3.535V7.628h3.535V6.2h-4.961z"
				clipRule="evenodd"
			></path>
			<path
				fill="#000"
				d="M26.729 11.783c0 1.116.186 2.108.558 2.914.31.745.806 1.24 1.426 1.737.93.744 2.295 1.116 4.217 1.116h3.101v-2.108h-3.1c-1.613 0-2.667-.435-3.35-1.24-.496-.621-.744-1.365-.744-2.357 0-1.055.31-1.799.868-2.357.683-.744 1.86-1.116 3.411-1.116h2.977v-2.17h-3.225a9.17 9.17 0 00-2.418.31c-.745.185-1.303.371-1.86.805-.559.497-1.861 1.923-1.861 4.466z"
			></path>
			<path
				fill="#000"
				fillRule="evenodd"
				d="M22.078 17.55c1.364 0 2.046-.31 2.666-.992.682-.682.806-1.489.806-2.109 0-1.364-.558-2.294-1.674-2.79h-.062.062c.496-.249 1.116-.807 1.116-2.42 0-.867-.31-1.55-.93-2.108-.682-.62-1.612-.93-2.729-.93h-5.581V17.55h6.325zm-4.093-6.946V8.248l-.31.124h3.596c.62 0 1.675 0 1.675 1.24 0 .496-.186.496-.558.682-.372.186-.807.186-1.117.186h-3.597.31v.124zm0 2.17v-.185h-.31 3.906c.373 0 .869.062 1.303.31.372.248.558.806.558 1.24 0 .372-.124.682-.31.93-.372.372-1.054.31-1.55.31h-3.97.373v.125-2.73z"
				clipRule="evenodd"
			></path>
			<path
				fill="#000"
				d="M4.775 11.783c0 1.116.186 2.108.558 2.914.31.745.807 1.24 1.427 1.737.93.744 2.294 1.116 4.217 1.116h3.1v-2.108h-3.1c-1.613 0-2.667-.435-3.35-1.24-.495-.621-.743-1.365-.743-2.357 0-1.055.31-1.799.868-2.357.682-.744 1.86-1.116 3.41-1.116h2.978v-2.17h-3.163a9.17 9.17 0 00-2.419.31c-.744.185-1.302.371-1.86.805-.62.497-1.923 1.923-1.923 4.466zM3.101 6.2H.992V17.55h2.109V6.201z"
			></path>
		</svg>
	);
};

export default icbc;
